import React, { useState, useMemo } from 'react';
import { List, useTable, EditButton, ShowButton, DeleteButton } from '@refinedev/antd';
import { Table, Space, Tag, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { RoleDto } from '@wellverse/shared-ts';

export const RoleList: React.FC = () => {
  const { tableProps } = useTable<RoleDto>({
    resource: 'roles',
    pagination: { current: 1, pageSize: 20 },
  });

  const [searchText, setSearchText] = useState('');

  const filteredData = useMemo(() => {
    if (!searchText) return tableProps.dataSource;
    const lower = searchText.toLowerCase();
    return tableProps.dataSource?.filter((item: any) =>
      item.name?.toLowerCase().includes(lower) ||
      item.description?.toLowerCase().includes(lower)
    );
  }, [tableProps.dataSource, searchText]);

  return (
    <List resource="roles">
      <div style={{ marginBottom: 16 }}>
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search by name, description..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 320 }}
          allowClear
        />
      </div>
      <Table {...tableProps} dataSource={filteredData} rowKey="id">
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column dataIndex="description" title="Description" />
        <Table.Column
          dataIndex="permissions"
          title="Permissions"
          render={(permissions: RoleDto['permissions']) => (
            <Space size={[4, 4]} wrap>
              {(permissions || []).slice(0, 5).map((p) => (
                <Tag
                  key={p.id}
                  style={{
                    borderColor: '#3ecf8e',
                    color: '#3ecf8e',
                    background: '#3ecf8e15',
                    borderRadius: 9999,
                    padding: '2px 10px',
                    fontSize: 12,
                  }}
                >
                  {p.resource}:{p.action}
                </Tag>
              ))}
              {(permissions || []).length > 5 && (
                <Tag
                  style={{
                    borderColor: '#898989',
                    color: '#898989',
                    background: '#89898915',
                    borderRadius: 9999,
                    padding: '2px 10px',
                    fontSize: 12,
                  }}
                >
                  +{(permissions || []).length - 5} more
                </Tag>
              )}
            </Space>
          )}
        />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_, record: RoleDto) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} resource="roles" />
              <ShowButton hideText size="small" recordItemId={record.id} resource="roles" />
              <DeleteButton hideText size="small" recordItemId={record.id} resource="roles" />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
